if (!customElements.get('promi-review-label')) {
  customElements.define('promi-review-label', class extends HTMLElement {
    connectedCallback() {
      const translate = () => {
        this.querySelectorAll('.trw-text').forEach(label => {
          if (/^reviews?$/i.test(label.textContent.trim())) {
            label.textContent = this.dataset.label;
          }
        });
      };
      this.observer = new MutationObserver(translate);
      this.observer.observe(this, { childList: true, subtree: true, characterData: true });
      translate();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
